/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonActions, FormActionPipelines, FormFlowState } from '@gh/builder-shared';
import { createDialogRoute, FormState, FormStateBuilder, IS_REGION_AU_OR_NZ, NumberTypes } from '@gh/common-shared';
import { AutocompleteLoadMoreEvent, DialogInput, FormMode, STYLES_DIALOG_LAYOUT } from '@gh/core-ui';
import { mapTo$ } from '@gh/rx/operators';
import { JobDppDetailsDialogConfig, LeadDetailsBusinessService } from '../../resources/lead-details-business.service';
import { JobDppDetails } from '../../resources/lead.model';
import { SiteListItem } from '../../resources/quote.model';

@Component({
  selector: 'gh-job-dpp-create-dialog',
  template: require('./job-dpp-create-dialog.component.html'),
  styles: [STYLES_DIALOG_LAYOUT],
})
export class JobDppCreateDialogComponent implements DialogInput<JobDppDetailsDialogConfig>, OnInit {
  input: JobDppDetailsDialogConfig;
  form: FormState<JobDppDetails>;
  sites: SiteListItem[];
  isAuOrNzRegion = IS_REGION_AU_OR_NZ;

  constructor(private formStateBuilder: FormStateBuilder,
              private business: LeadDetailsBusinessService,
              private dialogRef: MatDialogRef<any>,
              private commonActions: CommonActions,
              private pipelines: FormActionPipelines) {

  }

  get customerName(): string {
    return this.input.customerName;
  }

  get salesFolderName(): string {
    return this.input.salesFolderName;
  }

  get address(): string {
    return this.input.address;
  }

  ngOnInit(): void {
    const { salesFolderId } = this.input;

    this.business.findAllSites(salesFolderId).subscribe((res) => {
      this.sites = res;
    });

    this.form = this.formStateBuilder.buildPlain({
      mode: FormMode.CreateMode,
      value: { salesFolderId },
      children: {
        salesFolderId: void 0,
        baseDesign: { required: true },
        site: { required: true },
        estimateCost: { type: NumberTypes.Price },
        memo: void 0,
      },
    });
  }

  onProcess(): void {
    const flow = this.pipelines.process({
      execute: this.commonActions.async((state: FormFlowState<JobDppDetails>) =>
        this.business.createDppJob(this.input.salesFolderId, state.value).pipe(mapTo$(state))),
      finish: (state) => this.dialogRef.close(true),
    });

    flow.run({ form: this.form, value: this.form.submitValue });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  loadBaseDesigns(event: AutocompleteLoadMoreEvent): void {
    event.load(this.business.findAllBaseDesignsByName(event.query));
  }
}

export const jobDppDetailsDialogRoute = createDialogRoute({
  component: JobDppCreateDialogComponent,
  config: { width: '900px', minHeight: '650px', maxHeight: '95vh', autoFocus: false },
});
